import { useCallback, useRef, useEffect } from "react";

const DRAFT_KEY = "campaignForm_draft";

const debounce = (fn, ms) => {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
};

/**
 * Persiste y restaura el estado del formulario de campañas en sessionStorage.
 * Los objetos File no se guardan (uploadedFile se pierde al recargar).
 */
export const useCampaignDraft = () => {
  const debouncedSave = useRef(null);

  useEffect(() => {
    debouncedSave.current = debounce((data) => {
      try {
        sessionStorage.setItem(DRAFT_KEY, JSON.stringify(data));
      } catch (e) {
        // sessionStorage lleno o no disponible
        console.warn("Error guardando borrador de campaña:", e);
      }
    }, 300);
  }, []);

  const saveDraft = useCallback((state) => {
    debouncedSave.current?.(state);
  }, []);

  const loadDraft = useCallback(() => {
    try {
      const raw = sessionStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }, []);

  const clearDraft = useCallback(() => {
    try {
      sessionStorage.removeItem(DRAFT_KEY);
    } catch {
      // ignorar
    }
  }, []);

  return { saveDraft, loadDraft, clearDraft };
};

export default useCampaignDraft;
